import * as React from "react"
import { tv, VariantProps } from "tailwind-variants"

import { cn } from "@/utils/styles"

const inputVariants = tv({
  base: [
    "flex h-10 w-full",
    "px-3 py-2",
    "rounded-md bg-background",
    "border-input border",
    "text-base md:text-sm",
    "placeholder:text-muted-foreground",
    "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
    "focus-visible:outline-none",
    "ring-offset-background",
    "disabled:cursor-not-allowed disabled:bg-gray-02 disabled:border-none",
    "[&:-webkit-autofill]:bg-white [&:-webkit-autofill]:border-input [&:-webkit-autofill]:text-foreground",
    "[&:-webkit-autofill:hover]:bg-white [&:-webkit-autofill:hover]:border-input [&:-webkit-autofill:hover]:text-foreground",
    "[&:-webkit-autofill:focus]:bg-white [&:-webkit-autofill:focus]:border-input [&:-webkit-autofill:focus]:text-foreground",
  ],
  defaultVariants: {
    size: "md",
    color: "primary",
  },
  variants: {
    color: {
      primary: "focus-visible:border-primary-07",
    },
    size: {
      sm: "px-3 py-2 h-[40px]",
      md: "px-4 py-3 h-[48px]",
      lg: "px-5 py-4 h-[56px]",
    },
  },
})

type InputElementProps = React.InputHTMLAttributes<HTMLInputElement>
type InputVariants = VariantProps<typeof inputVariants>
type InputProps = Omit<InputElementProps, "size"> & InputVariants

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, size = "md", color = "primary", value, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ className, size, color }))}
        ref={ref}
        autoComplete="off"
        value={value === null ? "" : value}
        {...props}
      />
    )
  },
)
Input.displayName = "Input"

export { Input }
